











































export default {
    name: 'Chip',
    props: {

        /**
         * By default all chips can be removed again, if you set this to false this one can't
         */
        removable: {
            type: Boolean,
            default: true
        },

        /**
         * Allows you to disable the chip's interaction
         */
        disabled: {
            type: Boolean,
            default: false
        },

        /**
         * @deprecated it does nothing(?) o.O
         */
        item: String,

        /**
         * @deprecated use "disabled" instead
         */
        isDisabled: {
            type: [Boolean, Number],
            validator: (v) => [-1, true, false].indexOf(v) !== -1,
            default: -1
        },

        /**
         * @deprecated use "removable" instead
         */
        isRemovable: {
            type: [Boolean, Number],
            validator: (v) => [-1, true, false].indexOf(v) !== -1,
            default: -1
        }
    },
    computed: {
        /**
         * The list of the css classes based on the given props
         */
        classes(): Object
        {
            return {
                'chip--nonRemovable': !this.removableInternal,
                'chip--disabled': this.disabledInternal
            };
        },

        /**
         * @deprecated temporary helper to handle both the legacy and the new disabled state
         */
        removableInternal(): boolean
        {
            if (this.isRemovable !== -1) {
                return this.isRemovable;
            }
            return this.removable;
        },

        /**
         * @deprecated temporary helper to handle both the legacy and the new disabled state
         */
        disabledInternal(): boolean
        {
            if (this.isDisabled !== -1) {
                return this.isDisabled;
            }
            return this.disabled;
        }
    },
    methods: {
        /**
         * Removes this chip from the chip list
         * This has an effect only if triggered inside a chips list
         * @public
         */
        remove(): void
        {
            this.$emit('remove');
        },

        /**
         * Handles keyboard events
         */
        onKeyUp(e: KeyboardEvent): void
        {
            if (e.code === 'Delete' && this.removableInternal) {
                this.remove();
            }
        },

        /**
         * Emits a non-native "click" event if the chip was clicked
         */
        onClick()
        {
            if (!this.disabledInternal) {
                this.$emit('click');
            }
        },

        /**
         * Emits the close event if the chip is allowed to be closed
         */
        onRemoveClick()
        {
            this.remove();
        }
    }
};
